function trackEvent(target: string) {
  window.gtag?.('event', target, { send_to: 'AW-356205517/3b-8CMWH1PECEM2H7akB' })
}

export default {
  trackEvent,
}
